import React from 'react';
import { Icon, Button } from '@scuf/common';
import '../GenericPage/GenericPage.scss';
import { useHistory } from 'react-router-dom';
import authService from '../../authService';

export default function LoginFailurePage({
  message,
  buttonContent
}: {
  message: string;
  buttonContent?: string;
}) {
  let history = useHistory();
  return (
    <div className="un-authorized-container">
      <div className="un-authorized">
        <Icon name="badge-warning" size="xlarge" />
        <h1 id="headerPageNotFound">{message}</h1>
        <Button
          className="routeToHomeButton"
          onClick={() =>
            //login is nothing but prompt for IAM
            authService.login('login')
          }
          type="secondary"
          content={buttonContent}
        />
      </div>
    </div>
  );
}
